import { Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { toLocale } from '$func/text'

const StyledTypography = styled(Typography)(() => ({
  display: 'block',
  marginLeft: '8px',
}))

export function LengthVerifier({
  value,
  maxLength,
  disableErrorMode,
}: {
  value: string
  maxLength: number
  disableErrorMode?: boolean
}) {
  return (
    <Stack flexDirection="row" justifyContent="end">
      <StyledTypography
        variant="caption1"
        color={
          disableErrorMode || value.length < maxLength
            ? 'primary.main'
            : 'error.main'
        }
      >
        {toLocale(value.length)}/{toLocale(maxLength)}
      </StyledTypography>
    </Stack>
  )
}

LengthVerifier.defaultProps = {
  disableErrorMode: false,
}
